const SQ_FT_PER_ACRE = 43560;

/** Below this the panel/PDF show square feet; acres at one decimal above. */
export const SQ_FT_THRESHOLD_ACRES = 0.5;

/**
 * Human-readable area for the drawn-polygon summary. Small areas (a single
 * intersection, a sidewalk repair) round to "0.0 ac", so under half an acre
 * they're shown in whole square feet instead.
 */
export function formatArea(acres: number | null | undefined): string {
  if (acres === null || acres === undefined) return '';
  const a = Number(acres);
  if (!Number.isFinite(a) || a < 0) return '';
  if (a < SQ_FT_THRESHOLD_ACRES) {
    return `${Math.round(a * SQ_FT_PER_ACRE).toLocaleString('en-US')} sq ft`;
  }
  return `${a.toLocaleString('en-US', { minimumFractionDigits: 1, maximumFractionDigits: 1 })} ac`;
}
